import React, { useEffect, useRef } from "react";
import "../styles/addexp.css";
import VanillaTilt from "vanilla-tilt";
import { AnimatePresence, motion } from "framer-motion";
import { useAudio } from "./AudioContext";

export default function AddExp({
  role,
  company,
  description,
  from,
  to,
  location,
  type,
}) {
  const tiltRef = useRef(null);
  const { playHover, pauseHover } = useAudio();

  const playSound = (sound) => {
    playHover(sound);
  };

  const stopSound = () => {
    pauseHover();
  };

  useEffect(() => {
    if (tiltRef.current) {
      VanillaTilt.init(tiltRef.current, {
        max: 5,
        speed: 400,
        glare: true,
        "max-glare": 1,
        gyroscope: false,
      });
    }
  }, []);
  return (
    <AnimatePresence>
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        exit={{ opacity: 0, x: -100 }}
        className="addexp"
        ref={tiltRef}
        onMouseEnter={() => playSound(0.5)}
        onMouseLeave={stopSound}
      >
        <div className="roleanddate">
          <div className="role">
            <h2>{role}</h2>
          </div>
          <div className="date">
            <h3>
              {from} - {to}
            </h3>
          </div>
        </div>
        <div className="companyandlocation">
          <div className="company">
            <h3>{company}</h3>
          </div>
          <div className="location">
            <h3>{location}</h3>
          </div>
        </div>
        <div className="desandtype">
          <div className="des">
            <p>{description}</p>
          </div>
          <div className="type">
            <h4>{type}</h4>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
